
import AuthService from '../services/auth.service';
import AppStorageService from '../services/app-storage.service';

const user = AppStorageService.getUser();
const initialState = user
  ? { status: { loggedIn: true }, user }
  : { status: { loggedIn: false }, user: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    // User login
    login({ commit }, user) {
      return AuthService.login(user).then(
        user => {
          commit('loginSuccess', user);
          return Promise.resolve(user);
        },
        error => {
          commit('loginFailure');
          return Promise.reject(error);
        }
      );
    },
    // User logout
    logout({ commit }) {
      AuthService.logout();
      commit('logout');
    }
  },
  mutations: {
    // Login success
    loginSuccess(state, user) {
      console.log("login")
      state.status.loggedIn = true;
      state.user = user;
    },
    // Login failed
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
    },
    // User logout
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
    }
  }
};
